// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLICK_HERE_TO_ENTER_DESCRIPTION = "Klikni sem a zadaj popis";
export const GO_BACK_TO_GROUP_POST = "Sp\u00e4\u0165 na spr\u00e1vu";
export const IMAGE_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie obr\u00e1zka";
